import React from 'react';
import {styled} from '@mui/material/styles';
import Tooltip, {TooltipProps, tooltipClasses} from '@mui/material/Tooltip';

const CustomTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `rgba(61, 61, 61, 1)`,
    borderRadius: '2px',
    fontSize: '14px',
    maxWidth: '275px',
    opacity: '1',
    padding: '8px 16px 10px'
  },
  [`& .${tooltipClasses.arrow}`]: {
    '&:before': {
      color: 'rgba(61, 61, 61, 1)'
    }
  }
});

export default CustomTooltip;
